'use client';
import { isEqual } from 'lodash-es';
import { useEffect, useRef } from 'react';

function useDeepCompareEffect(callback: React.EffectCallback, dependencies: unknown[]) {
  const currentDependenciesRef = useRef<unknown[]>([]);

  if (!isEqual(currentDependenciesRef.current, dependencies)) {
    currentDependenciesRef.current = dependencies;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [currentDependenciesRef.current]);
}

export default useDeepCompareEffect;
